import { createPortal } from 'react-dom';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { PRINT_SERIF } from './printDocument';

export function PrintField({ label, value, compact = false }) {
  return (
    <div style={{ display: 'flex', alignItems: 'flex-end', marginBottom: compact ? '5px' : '10px', gap: '8px' }}>
      <span style={{ whiteSpace: 'nowrap', fontWeight: 500 }}>{label}:</span>
      <span style={{ flex: 1, borderBottom: '1px solid #000', minWidth: '80px', paddingBottom: '1px' }}>
        {value || ''}
      </span>
    </div>
  );
}

PrintField.propTypes = {
  label: PropTypes.string,
  value: PropTypes.any,
  compact: PropTypes.bool,
};

export function PrintRow({ fields, compact = false }) {
  return (
    <div style={{ display: 'flex', gap: compact ? '14px' : '24px', marginBottom: compact ? '5px' : '10px' }}>
      {fields.map(({ label, value, flex = 1 }, i) => (
        // eslint-disable-next-line react/no-array-index-key
        <div key={i} style={{ flex, display: 'flex', alignItems: 'flex-end', gap: '6px', minWidth: 0 }}>
          <span style={{ whiteSpace: 'nowrap', fontWeight: 500 }}>{label}:</span>
          <span style={{ flex: 1, borderBottom: '1px solid #000', paddingBottom: '1px', overflowWrap: 'anywhere' }}>{value || ''}</span>
        </div>
      ))}
    </div>
  );
}

PrintRow.propTypes = {
  fields: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.any,
      flex: PropTypes.number,
    })
  ),
  compact: PropTypes.bool,
};

export function PrintSectionHeader({ title, compact = false }) {
  return (
    <div style={{ textAlign: 'center', margin: compact ? '10px 0 6px' : '16px 0 12px' }}>
      <span style={{ fontWeight: 700, textDecoration: 'underline', fontSize: '13px', textTransform: 'uppercase' }}>
        {title}
      </span>
    </div>
  );
}

PrintSectionHeader.propTypes = {
  title: PropTypes.string,
  compact: PropTypes.bool,
};

export function PrintTextBlock({ label, value }) {
  return (
    <div style={{ marginBottom: '10px' }}>
      <div style={{ fontWeight: 500, marginBottom: '4px' }}>{label}:</div>
      <div style={{ whiteSpace: 'pre-wrap', minHeight: '40px', border: '1px solid #000', padding: '6px' }}>
        {value || ''}
      </div>
    </div>
  );
}

PrintTextBlock.propTypes = {
  label: PropTypes.string,
  value: PropTypes.any,
};

export default function PrintShell({ printClass, formTitle, children }) {
  const { t } = useTranslation();
  return createPortal(
    <>
      <div className={printClass}>
        <div style={{ maxWidth: '700px', margin: '0 auto', padding: '20px', fontFamily: PRINT_SERIF, fontSize: '13px' }}>
          <div style={{ textAlign: 'center', marginBottom: '20px' }}>
            <div style={{ fontSize: '22px', fontWeight: 700, letterSpacing: '1px' }}>
              {t('print_church_name')}
            </div>
            <div style={{ fontSize: '18px', fontWeight: 700 }}>
              {formTitle}
            </div>
          </div>

          {children}

          <div style={{ textAlign: 'center', marginTop: '40px', fontSize: '11px' }}>
            1940 University Avenue, Bronx NY, 10453 &nbsp; Tel: 718-583-0120 &nbsp; Fax: 718-583-1444
          </div>
        </div>
      </div>

      <style>{`
        .${printClass} { display: none; }
        @media print {
          body > *:not(.${printClass}) { display: none !important; }
          .${printClass} { display: block !important; }
        }
      `}</style>
    </>,
    document.body
  );
}

PrintShell.propTypes = {
  printClass: PropTypes.string.isRequired,
  formTitle: PropTypes.string,
  children: PropTypes.node,
};
